var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0455 5.29498H20.2155V3.29498H8.04547L10.0455 5.29498ZM15.0455 10.295H17.2155V8.29498H13.0455L15.0455 10.295ZM13.2155 14.125V15.295H9.21547V13.295H12.3855L9.38547 10.295H5.21547V8.29498H7.38547L4.38547 5.29498H2.21547V3.29498H2.38547L0.605469 1.51498L2.01547 0.10498L20.3955 18.485L18.9855 19.895L13.2155 14.125Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.774f5e539a0acf63f917260e87de2fd0.svg";
export { ForwardRef as ReactComponent };